var e = "/static/d8c3841f41242dcc.png";

export { e as default };
//# sourceMappingURL=month_reload.png.js.map
